export const handleTUTermsRedirect = () => {
  const url = process.env.REACT_APP_T_C;
  window.open(url, "_blank", "noopener,noreferrer");
};